import React from "react";
import VideoUpgrade from "../../components/videoUpgradeVonage/VideoUpgradeVonage";

const UpgradeDashboardVonage = () => {
  return <VideoUpgrade />; 
};

export default UpgradeDashboardVonage;
